import React from 'react';
import { connect } from 'react-redux';
import CreateArmyListUnit from '../make/unit/new/create-army-list-unit';
import Repeater from '@Utils/Repeater';
import ArmyListUnits from './ArmyListUnits';
import WarningMessage from '@Selectors/builder/myArmyList/make/unit/edit/warning/WarningMessage';
import { AppState } from '@Redux/store';
import UnitOrganisationPoints from './UnitOrganisationPoints';
import { Col } from 'reactstrap';
import { checkContraintsPresenter } from '@Selectors/builder/myArmyList/make/validation/check-contraints.presenter';

const MinimalArmyListMake: React.FC<ArmyListMakeProps> = ({ hasWarning, warning }) => {
  return <div className="builder-edit-app row justify-content-center">
    {hasWarning && (<Col xs={12}>
      <Repeater data={warning} indexPrefix="warning">
        {
          (item: WarningMessage) =>
            <p className="highlight-red">{item.message}</p>
        }
      </Repeater>
    </Col>)}
    <Col xs={12} md={4}>
      <UnitOrganisationPoints />
      <CreateArmyListUnit />
    </Col>
    <Col xs={12} md={8}>
      <ArmyListUnits />
    </Col>
  </div>;
};

const mapStateToProps = (state: AppState) => {
  const warning = checkContraintsPresenter(state);
  return {
    hasWarning: warning.length > 0,
    warning: warning
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(MinimalArmyListMake);

type ArmyListMakeProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
